import { m as motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useCategories } from "@/hooks/useCategories";

interface PortfolioFilterProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export function PortfolioFilter({
  activeCategory,
  onCategoryChange,
}: PortfolioFilterProps) {
  const { categories, isLoading } = useCategories();

  if (isLoading) {
    return (
      <div className="flex flex-wrap justify-center gap-2 md:gap-3">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-9 w-24 bg-muted animate-pulse rounded-md" />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap justify-center gap-2 md:gap-3">
      <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
        <Button
          variant={activeCategory === "All" ? "default" : "outline"}
          size="sm"
          onClick={() => onCategoryChange("All")}
          className="text-sm"
        >
          All
        </Button>
      </motion.div>
      {categories.map((category) => (
        <motion.div
          key={category.id}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <Button
            variant={activeCategory === category.name ? "default" : "outline"}
            size="sm"
            onClick={() => onCategoryChange(category.name)}
            className="text-sm"
          >
            {category.name}
          </Button>
        </motion.div>
      ))}
    </div>
  );
}
